export const domoEmbedSections = {
  count: 1,
  rows: [
    {
      archived: false,
      id: 1,
      name: 'Patient Outcomes',
      priority: 2,
    },
  ],
};

export const createdDomoEmbedSection = {
  name: 'Onboarding and Demographics',
  priority: 1,
};

export const editedDomoEmbedSection = {
  name: 'Learning Insights',
  priority: 2,
};
